import { useEffect, useState } from "react";
import DraggableList from "../draggableList";
import InteractionProductList from "../interactionProductList";
import "./style.css";
import useAppAccessor from "../../../../hooks/useappAccessor";
import InteractionIframe from "../interactionIframe";
import { TfiClose } from "react-icons/tfi";
import InteractionShoppingCart from "../interactionShoppingCart";
import InteractionShoppingCartTranont from "../interactionShoppingCartTranont";
import InteractionShoppingCartPartnerCo from "../interactionShoppingCartPartnerCo";
import { No_Interactions } from "../../../../assets/icons";
import { getProductDetail } from '../../interaction.actions';
import useAppDispatch from "../../../../hooks/useAppDispatch";
import { getBrandColor } from "../../../../utils/brand.util";

const isHost = () => {
  return window.location.href.indexOf("/stream") > -1;
};

const InteractionMain = () => {
  const [isEditable, setIsEditable] = useState(false);
  const [isDone, setIsDone] = useState(false);
  const { getInteractions } = useAppAccessor();
  const { interactionData } = getInteractions();
  const [isShowIframe, setIsShowIframe] = useState(false);
  const [showProductList,setShowProductList] = useState(false);
  const [toCart,setToCart] = useState(false);
  const [productList,setProductList] = useState<any>([])
  const [iframeURL, setIframeURL] = useState("");
  const { getLiveMainData, getControls, getUserData } = useAppAccessor();
  const { language, client } = getUserData();
  const { productDetail} = getInteractions();
  const dispatch = useAppDispatch();
  const brandColor = getBrandColor(client);

  useEffect(() => {
   // console.log("interaction Data in redux====>Main", interactionData);
  }, [interactionData]);

  useEffect(() => {
   // console.log("productDetail==>", productDetail.fromCarsoul);
    if (productDetail?.fromCarsoul) {
      setShowProductList(true);
    }
  }, [productDetail?.fromCarsoul12]);

  return (
    <>
      {isHost() && (
        <div className="flex justify-between items-center px-4 py-2.5 border-b border-[#2A2A2A]" style={{ backgroundColor: '#2A2A2A' }}>
          {isEditable ? (
            <>
              <button
                className="text-sm text-gray-400 hover:text-white cursor-pointer transition-colors duration-200 font-medium"
                onClick={() => {
                  setIsDone(false);
                  setTimeout(() => {
                    setIsEditable(false);
                  }, 200);
                }}
              >
                {language["cancel"]}
              </button>
              <button
                className="text-sm text-white px-4 py-1.5 rounded-lg cursor-pointer transition-all duration-200 font-medium shadow-sm hover:shadow-md"
                style={{ backgroundColor: brandColor }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.opacity = "0.9";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.opacity = "1";
                }}
                onClick={() => {
                  setIsDone(true);
                  setTimeout(() => {
                    setIsEditable(false);
                  }, 200);
                  setTimeout(() => {
                    setIsDone(false);
                  }, 1000);
                }}
              >
                {language["done"]}
              </button>
            </>
          ) : (
            <>
              <div></div>
              <button
                className="text-sm text-gray-300 hover:text-white cursor-pointer transition-colors duration-200 font-medium flex items-center gap-1.5 px-2 py-1 hover:bg-[#1F1F1F] rounded-md"
                onClick={() => {
                  setIsEditable(true);
                }}
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                </svg>
                {language["Edit"]}
              </button>
            </>
          )}
        </div>
      )}
      <div className=" overflow-y-auto listContainer" id="iFrameContainer" style={interactionData.filter((data:any) => data.attributes.shouldShow === true).length === 0 ? {backgroundColor:'rgb(65, 65, 65)'} : {backgroundColor:'white'}}>
      {interactionData.length === 0 && !isEditable && (
        <div className="flex flex-col items-center justify-center h-full px-6 py-12">
          <div className="flex flex-col items-center max-w-sm">
            <div className="mb-6 p-6 bg-[#2A2A2A] rounded-2xl opacity-80">
              <img 
                src={No_Interactions} 
                alt="No interactions" 
                className="w-16 h-16 opacity-90"
              />
            </div>
            <h3 className="text-white text-lg font-semibold mb-2 text-center">
              {language['no_interactions'] || 'No Interactions Yet'}
            </h3>
            <p className="text-gray-400 text-sm text-center leading-relaxed mb-6 max-w-xs">
              {isHost() 
                ? language['no_interactions_description'] || 'Add links, products, or media to engage with your audience during the stream.'
                : language['no_interactions_attendee'] || 'Interactions will appear here when the host adds them.'}
            </p>
            {isHost() && (
              <div className="flex items-center gap-2 text-xs text-gray-500">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span>Click the + button above to get started</span>
              </div>
            )}
          </div>
        </div>
        )}
        {!isShowIframe && (
          <>
            {!isEditable && !showProductList && interactionData.length !== 0 && (
              <InteractionProductList
              data={interactionData.filter((item: any) => item.interaction_type === "shop_com")}
              toggleProductList={(flag: boolean)=>{setShowProductList(flag)}}
              toDetail = {() => {setShowProductList(false); setToCart(false);} }
              toCart = {()=>{setIsEditable(false); setShowProductList(true); setToCart(true);
                var tmpProduct = productDetail;
                  // tmpProduct['fromCarsoul'] = false;
                  dispatch(getProductDetail(tmpProduct));
              }}
                iframeURL={(url: any) => {
                  setIframeURL(url);
                }}
                showIframe={(flag: any) => {
                  setIsShowIframe(flag);
                }}
              ></InteractionProductList>
            )}

            {/* <InteractionShoppingCart></InteractionShoppingCart> */}

            {
              !isEditable && showProductList && (
                client.toLowerCase().includes('tranont') ? (
                  <InteractionShoppingCartTranont showCart={toCart} toggleProductList={(flag: boolean) => { setShowProductList(flag); }} />
                ) : client.toLowerCase().trim().includes('partner.co') ? (
                  <InteractionShoppingCartPartnerCo showCart={toCart} toggleProductList={(flag: boolean) => { setShowProductList(flag); }} />
                ) : (
                  <InteractionShoppingCart showCart={toCart} toggleProductList={(flag: boolean) => { setShowProductList(flag); }} />
                )
              )
            }
            {isEditable && (
              <DraggableList isCLickedDone={isDone}></DraggableList>
            )}
          </>
        )}
        {isShowIframe && (
          <InteractionIframe urlData={iframeURL}></InteractionIframe>
        )}
      </div>

      {isShowIframe && (
        <div
          className="flex w-full justify-between px-3 h-10 items-center"
          style={{ position: "absolute", top: "-9.5%" }}
        >
          <div className="h-2.5 w-2.5"></div>
          <TfiClose
            color="#DEDEDE"
            size={20}
            cursor="pointer"
            style={{ marginRight: 10 }}
            onClick={() => {
              setIsShowIframe(false);
            }}
          />
        </div>
      )}

      {/* {isShowIframe&&<div className=" overflow-y-auto listContainer" id="iFrameContainer">
    <InteractionIframe
    urlData={iframeURL}></InteractionIframe>
    </div>} */}
    </>
  );
};
export default InteractionMain;
